import { Button } from '@/components/PageHeading';
import { StatusScreen } from '@/components/StatusScreen';

/**
 * The shell was asked for a screen that is not in the menu manifest at all.
 *
 * Unreachable through the sidebar today, and deliberately kept anyway — navigation is a key swap
 * rather than a route, so the key can only come from the manifest, but the moment real routing
 * arrives a typed URL is a live path to here. The same reasoning kept the "not built yet" fallback
 * around before this: a shell whose only answer to an unknown key is a blank content column is a
 * shell that fails silently.
 *
 * The way out is a menu key rather than a URL, for the same reason: there is no router to hand a
 * path to.
 */
export function NotFoundPage({ onHome }: { onHome?: () => void }) {
  return (
    <StatusScreen
      code="404"
      // The template's own 404 glyph, rather than the compass this used to draw. Same reasoning as
      // everywhere else in this codebase: where the theme has an answer, the theme is right.
      icon="ph-duotone ph-warning-circle"
      tone="warning"
      title="That screen does not exist"
      message="The page you asked for is not part of this application. It may have been renamed, or the link that sent you here is out of date."
      actions={
        onHome && (
          <Button variant="primary" icon="icon icon-arrow-left" onClick={onHome}>
            Back to the first screen
          </Button>
        )
      }
    />
  );
}
